<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="vozRecModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="reconhecendo">
                    <div class="modal-header">
                        <h5 class="modal-title">Reconhecimento de Voz</h5>
                            <button type="button" class="close" aria-label="Close" @click="fechar()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">

                        <div class="alert alert-danger" v-if="error">{{ error }}</div>

                        <template v-else> 

                            <small>Fale ao microfone:</small>

                            <div class="alert alert-info" id="textorec">
                                <span v-if="transcription && transcription.length" class="mr-3" style="white-space: pre;">{{ tratar_pontuacao(transcription.join(' ')) }}</span>
                                <!-- <span v-for="(word, idx) in transcription" :key="idx">{{ word }}</span> -->
                                <span class="text-muted">{{ runtimeTranscription }}</span>
                            </div>

                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <button type="button" class="btn btn-success" @click="copiar()">Copiar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    data() { 
        return { 
            reconhecendo: false,
            error: "", 
            runtimeTranscription: '',
            transcription: [],
            lang: 'pt-Br',
            recognition: null, 
        }
    },

    methods: { 
        copiar_clipboard (text) { 
            if (!navigator.clipboard) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position="fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            } else { 
                navigator.clipboard.writeText(text).then(function() {
                    console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Texto copiado para a área de transferência.",
                life: 3000
            });
        },

        fechar() { 
            $('#vozRecModal').modal('hide');
            this.reconhecendo = false;

            if ( this.recognition )
                this.recognition.abort();
        },

        copiar() { 
            const texto = this.transcription.join(' ') + this.runtimeTranscription;
            this.copiar_clipboard(this.tratar_pontuacao(texto.trim()));
            this.fechar();
        },

        abrir() { 
            this.runtimeTranscription = '';
            this.transcription = [];

            this.reconhecendo = true;
            $('#vozRecModal').modal('show');

            this.$nextTick(() => { 
                this.checkApi();
            });
        },

        tratar_pontuacao(texto) { 
            if ( !texto )
                return texto;

            const dic = [
                { from: ' vírgula', to: ',', },
                { from: ' ponto parágrafo', to: '.\n', },
                { from: ' ponto', to: '.', },
            ];

            dic.forEach(item => {
                if ( texto.indexOf(item.from) >= 0 ) { 
                    texto = texto.replace(item.from, item.to);
                }
            });

            return texto;
        },

        checkApi () {
            window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
            if (!window.SpeechRecognition) {
                this.error = 'Speech Recognition does not exist on this browser. Use Chrome or Firefox';
                return;
            }

            //this.recognition = new SpeechRecognition()
            this.recognition = new window.webkitSpeechRecognition;
            this.recognition.lang = this.lang
            this.recognition.interimResults = true
            this.recognition.addEventListener('result', event => {
                const text = Array.from(event.results)
                .map(result => result[0])
                .map(result => result.transcript)
                .join('')
                this.runtimeTranscription = text;
            })
            this.recognition.addEventListener('end', () => {
                if (this.runtimeTranscription !== '') {
                this.transcription.push(this.runtimeTranscription)
                this.$emit('onTranscriptionEnd', {
                    transcription: this.transcription,
                    lastSentence: this.runtimeTranscription
                })
                }
                this.runtimeTranscription = ''
                
                if ( this.reconhecendo )
                    this.recognition.start();
            })
            this.recognition.start();
        }
    }
}
</script>